/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CertificateRequestProductDto } from "./CertificateRequestProductDto.ts"
import type { CertificateTypeDto } from "./CertificateTypeDto.ts"
import type { ProductionSiteDto } from "./ProductionSiteDto.ts"

export const certificateByOrganizationCertificateRequestDtoStatusEnum = {
  OPENED: "OPENED",
  SUBMITTED: "SUBMITTED",
  REJECTED: "REJECTED",
  ACCEPTED: "ACCEPTED",
  CANCELED: "CANCELED",
} as const

export type CertificateByOrganizationCertificateRequestDtoStatusEnumKey =
  (typeof certificateByOrganizationCertificateRequestDtoStatusEnum)[keyof typeof certificateByOrganizationCertificateRequestDtoStatusEnum]

export type CertificateByOrganizationCertificateRequestDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  status: CertificateByOrganizationCertificateRequestDtoStatusEnumKey
  /**
   * @type string
   */
  productPurchaseOrderReference: string
  /**
   * @type object
   */
  productionSite: ProductionSiteDto
  /**
   * @type object
   */
  type: CertificateTypeDto
  /**
   * @type string
   */
  rejectionMessage: string | null
  /**
   * @type object
   */
  product: CertificateRequestProductDto
}
